import { useState, type ReactNode } from 'react';
import { cn } from './cn';

/**
 * Ouvre un document dans un nouvel onglet. L'adresse se demande au moment du
 * clic : avec Supabase, c'est une adresse signée qui expire après dix minutes.
 */
export function OuvrirDocument({
  adresse,
  className,
  children,
}: {
  adresse: () => Promise<string>;
  className?: string;
  children: ReactNode;
}) {
  const [erreur, setErreur] = useState(false);

  async function ouvrir() {
    setErreur(false);
    /* L'onglet s'ouvre tout de suite, dans le geste de l'utilisateur : ouvert
       après l'attente, il serait bloqué comme une fenêtre surgissante. */
    const onglet = window.open('', '_blank');
    try {
      const url = await adresse();
      if (onglet) onglet.location.href = url;
      else window.location.href = url;
    } catch {
      onglet?.close();
      setErreur(true);
    }
  }

  return (
    <button
      type="button"
      onClick={() => void ouvrir()}
      className={cn('text-left hover:text-primary', className)}
      title={erreur ? 'Le document n’a pas pu être ouvert.' : 'Ouvrir le document'}
    >
      {children}
      {erreur ? <span className="block text-xs text-danger">Ouverture impossible</span> : null}
    </button>
  );
}
